import { type TransportAirlineApiContext } from "../../../../common/utils/transport/airlineTransportContext";

export type Limos4ResolvedPaths =
  | { kind: "invalid_airline" }
  | {
      kind: "ok";
      mainPath: string;
      bookingsPath: string;
    };

export function resolveLimos4ApiPaths(transportContext: TransportAirlineApiContext): Limos4ResolvedPaths {
  if (transportContext.mode === "airline_missing_iata") {
    return { kind: "invalid_airline" };
  }
  if (transportContext.mode === "airline") {
    const base = `v1/airports/${encodeURIComponent(transportContext.iataCode)}/transports/limos4`;
    return {
      kind: "ok",
      mainPath: base,
      bookingsPath: `v1/airports/${encodeURIComponent(transportContext.iataCode)}/bookings`
    };
  }
  return {
    kind: "ok",
    mainPath: "transport/limos4",
    bookingsPath: "bookings"
  };
}
